import e, { isAxiosError as t } from "axios";
import { useMemo as n } from "react";
//#region ../backend-config/dist/index.es.js
var r = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function i(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var a = function(e) {
	try {
		return !!e();
	} catch {
		return !0;
	}
}, o = !a(function() {
	var e = (function() {}).bind();
	return typeof e != "function" || e.hasOwnProperty("prototype");
}), s = o, c = Function.prototype, l = c.call, u = s && c.bind.bind(l, l), d = s ? u : function(e) {
	return function() {
		return l.apply(e, arguments);
	};
}, f = d({}.isPrototypeOf), p = function(e) {
	return e && e.Math === Math && e;
}, m = p(typeof globalThis == "object" && globalThis) || p(typeof window == "object" && window) || p(typeof self == "object" && self) || p(typeof r == "object" && r) || (function() {
	return this;
})() || r || Function("return this")(), h = o, g = Function.prototype, _ = g.apply, v = g.call, y = typeof Reflect == "object" && Reflect.apply || (h ? v.bind(_) : function() {
	return v.apply(_, arguments);
}), ee = d, te = ee({}.toString), ne = ee("".slice), b = function(e) {
	return ne(te(e), 8, -1);
}, re = b, ie = d, ae = function(e) {
	if (re(e) === "Function") return ie(e);
}, oe = typeof document == "object" && document.all, se = {
	all: oe,
	IS_HTMLDDA: oe === void 0 && oe !== void 0
}, ce = se, le = ce.all, x = ce.IS_HTMLDDA ? function(e) {
	return typeof e == "function" || e === le;
} : function(e) {
	return typeof e == "function";
}, ue = {}, S = !a(function() {
	return Object.defineProperty({}, 1, { get: function() {
		return 7;
	} })[1] !== 7;
}), de = o, fe = Function.prototype.call, C = de ? fe.bind(fe) : function() {
	return fe.apply(fe, arguments);
}, pe = {}, me = {}.propertyIsEnumerable, he = Object.getOwnPropertyDescriptor;
pe.f = he && !me.call({ 1: 2 }, 1) ? function(e) {
	var t = he(this, e);
	return !!t && t.enumerable;
} : me;
var ge = function(e, t) {
	return {
		enumerable: !(e & 1),
		configurable: !(e & 2),
		writable: !(e & 4),
		value: t
	};
}, _e = d, ve = a, ye = b, be = Object, xe = _e("".split), Se = ve(function() {
	return !be("z").propertyIsEnumerable(0);
}) ? function(e) {
	return ye(e) === "String" ? xe(e, "") : be(e);
} : be, w = function(e) {
	return e == null;
}, Ce = w, we = TypeError, Te = function(e) {
	if (Ce(e)) throw we("Can't call method on " + e);
	return e;
}, Ee = Se, De = Te, T = function(e) {
	return Ee(De(e));
}, Oe = x, ke = se, Ae = ke.all, E = ke.IS_HTMLDDA ? function(e) {
	return typeof e == "object" ? e !== null : Oe(e) || e === Ae;
} : function(e) {
	return typeof e == "object" ? e !== null : Oe(e);
}, D = {}, je = D, Me = m, Ne = x, Pe = function(e) {
	return Ne(e) ? e : void 0;
}, Fe = function(e, t) {
	return arguments.length < 2 ? Pe(je[e]) || Pe(Me[e]) : je[e] && je[e][t] || Me[e] && Me[e][t];
}, Ie = typeof navigator < "u" && String(navigator.userAgent) || "", Le = m, Re = Ie, ze = Le.process, Be = Le.Deno, Ve = ze && ze.versions || Be && Be.version, He = Ve && Ve.v8, O, Ue;
He && (O = He.split("."), Ue = O[0] > 0 && O[0] < 4 ? 1 : +(O[0] + O[1])), !Ue && Re && (O = Re.match(/Edge\/(\d+)/), (!O || O[1] >= 74) && (O = Re.match(/Chrome\/(\d+)/), O && (Ue = +O[1])));
var We = Ue, Ge = We, Ke = a, qe = m.String, Je = !!Object.getOwnPropertySymbols && !Ke(function() {
	var e = Symbol("symbol detection");
	return !qe(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && Ge && Ge < 41;
}), Ye = Je && !Symbol.sham && typeof Symbol.iterator == "symbol", Xe = Fe, Ze = x, Qe = f, $e = Ye, et = Object, tt = $e ? function(e) {
	return typeof e == "symbol";
} : function(e) {
	var t = Xe("Symbol");
	return Ze(t) && Qe(t.prototype, et(e));
}, nt = String, rt = function(e) {
	try {
		return nt(e);
	} catch {
		return "Object";
	}
}, it = x, at = rt, ot = TypeError, st = function(e) {
	if (it(e)) return e;
	throw ot(at(e) + " is not a function");
}, ct = st, lt = w, ut = function(e, t) {
	var n = e[t];
	return lt(n) ? void 0 : ct(n);
}, dt = C, ft = x, pt = E, mt = TypeError, ht = function(e, t) {
	var n, r;
	if (t === "string" && ft(n = e.toString) && !pt(r = dt(n, e)) || ft(n = e.valueOf) && !pt(r = dt(n, e)) || t !== "string" && ft(n = e.toString) && !pt(r = dt(n, e))) return r;
	throw mt("Can't convert object to primitive value");
}, gt = { exports: {} }, _t = m, vt = Object.defineProperty, yt = function(e, t) {
	try {
		vt(_t, e, {
			value: t,
			configurable: !0,
			writable: !0
		});
	} catch {
		_t[e] = t;
	}
	return t;
}, bt = m, xt = yt, St = "__core-js_shared__", Ct = bt[St] || xt(St, {}), wt = Ct;
(gt.exports = function(e, t) {
	return wt[e] || (wt[e] = t === void 0 ? {} : t);
})("versions", []).push({
	version: "3.32.1",
	mode: "pure",
	copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
	license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
	source: "https://github.com/zloirock/core-js"
});
var Tt = gt.exports, Et = Te, Dt = Object, Ot = function(e) {
	return Dt(Et(e));
}, kt = d, At = Ot, jt = kt({}.hasOwnProperty), k = Object.hasOwn || function(e, t) {
	return jt(At(e), t);
}, Mt = d, Nt = 0, Pt = Math.random(), Ft = Mt(1 .toString), It = function(e) {
	return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Ft(++Nt + Pt, 36);
}, Lt = m, Rt = Tt, zt = k, Bt = It, Vt = Je, Ht = Ye, A = Lt.Symbol, Ut = Rt("wks"), Wt = Ht ? A.for || A : A && A.withoutSetter || Bt, j = function(e) {
	return zt(Ut, e) || (Ut[e] = Vt && zt(A, e) ? A[e] : Wt("Symbol." + e)), Ut[e];
}, Gt = C, Kt = E, qt = tt, Jt = ut, Yt = ht, Xt = j, Zt = TypeError, Qt = Xt("toPrimitive"), $t = function(e, t) {
	if (!Kt(e) || qt(e)) return e;
	var n = Jt(e, Qt), r;
	if (n) {
		if (t === void 0 && (t = "default"), r = Gt(n, e, t), !Kt(r) || qt(r)) return r;
		throw Zt("Can't convert object to primitive value");
	}
	return t === void 0 && (t = "number"), Yt(e, t);
}, en = tt, tn = function(e) {
	var t = $t(e, "string");
	return en(t) ? t : t + "";
}, nn = m, rn = E, an = nn.document, on = rn(an) && rn(an.createElement), sn = function(e) {
	return on ? an.createElement(e) : {};
}, cn = S, ln = a, un = sn, dn = !cn && !ln(function() {
	return Object.defineProperty(un("div"), "a", { get: function() {
		return 7;
	} }).a !== 7;
}), fn = S, pn = C, mn = pe, hn = ge, gn = T, _n = tn, vn = k, yn = dn, bn = Object.getOwnPropertyDescriptor;
ue.f = fn ? bn : function(e, t) {
	if (e = gn(e), t = _n(t), yn) try {
		return bn(e, t);
	} catch {}
	if (vn(e, t)) return hn(!pn(mn.f, e, t), e[t]);
};
var xn = a, Sn = x, Cn = /#|\.prototype\./, wn = function(e, t) {
	var n = En[Tn(e)];
	return n === On ? !0 : n === Dn ? !1 : Sn(t) ? xn(t) : !!t;
}, Tn = wn.normalize = function(e) {
	return String(e).replace(Cn, ".").toLowerCase();
}, En = wn.data = {}, Dn = wn.NATIVE = "N", On = wn.POLYFILL = "P", kn = wn, An = ae, jn = st, Mn = o, Nn = An(An.bind), Pn = function(e, t) {
	return jn(e), t === void 0 ? e : Mn ? Nn(e, t) : function() {
		return e.apply(t, arguments);
	};
}, M = {}, Fn = S && a(function() {
	return Object.defineProperty(function() {}, "prototype", {
		value: 42,
		writable: !1
	}).prototype !== 42;
}), In = E, Ln = String, Rn = TypeError, N = function(e) {
	if (In(e)) return e;
	throw Rn(Ln(e) + " is not an object");
}, zn = S, Bn = dn, Vn = Fn, Hn = N, Un = tn, Wn = TypeError, Gn = Object.defineProperty, Kn = Object.getOwnPropertyDescriptor, qn = "enumerable", Jn = "configurable", Yn = "writable";
M.f = zn ? Vn ? function(e, t, n) {
	if (Hn(e), t = Un(t), Hn(n), typeof e == "function" && t === "prototype" && "value" in n && Yn in n && !n[Yn]) {
		var r = Kn(e, t);
		r && r[Yn] && (e[t] = n.value, n = {
			configurable: Jn in n ? n[Jn] : r[Jn],
			enumerable: qn in n ? n[qn] : r[qn],
			writable: !1
		});
	}
	return Gn(e, t, n);
} : Gn : function(e, t, n) {
	if (Hn(e), t = Un(t), Hn(n), Bn) try {
		return Gn(e, t, n);
	} catch {}
	if ("get" in n || "set" in n) throw Wn("Accessors not supported");
	return "value" in n && (e[t] = n.value), e;
};
var Xn = S, Zn = M, Qn = ge, P = Xn ? function(e, t, n) {
	return Zn.f(e, t, Qn(1, n));
} : function(e, t, n) {
	return e[t] = n, e;
}, $n = m, er = y, tr = ae, nr = x, rr = ue.f, ir = kn, F = D, ar = Pn, I = P, or = k, sr = function(e) {
	var t = function(n, r, i) {
		if (this instanceof t) {
			switch (arguments.length) {
				case 0: return new e();
				case 1: return new e(n);
				case 2: return new e(n, r);
			}
			return new e(n, r, i);
		}
		return er(e, this, arguments);
	};
	return t.prototype = e.prototype, t;
}, L = function(e, t) {
	var n = e.target, r = e.global, i = e.stat, a = e.proto, o = r ? $n : i ? $n[n] : ($n[n] || {}).prototype, s = r ? F : F[n] || I(F, n, {})[n], c = s.prototype, l, u, d, f, p, m, h, g, _;
	for (f in t) l = ir(r ? f : n + (i ? "." : "#") + f, e.forced), u = !l && o && or(o, f), m = s[f], u && (e.dontCallGetSet ? (_ = rr(o, f), h = _ && _.value) : h = o[f]), p = u && h ? h : t[f], !(u && typeof m == typeof p) && (g = e.bind && u ? ar(p, $n) : e.wrap && u ? sr(p) : a && nr(p) ? tr(p) : p, (e.sham || p && p.sham || m && m.sham) && I(g, "sham", !0), I(s, f, g), a && (d = n + "Prototype", or(F, d) || I(F, d, {}), I(F[d], f, p), e.real && c && (l || !c[f]) && I(c, f, p)));
}, cr = Math.ceil, lr = Math.floor, ur = Math.trunc || function(e) {
	var t = +e;
	return (t > 0 ? lr : cr)(t);
}, dr = function(e) {
	var t = +e;
	return t !== t || t === 0 ? 0 : ur(t);
}, fr = dr, pr = Math.max, mr = Math.min, hr = function(e, t) {
	var n = fr(e);
	return n < 0 ? pr(n + t, 0) : mr(n, t);
}, gr = dr, _r = Math.min, vr = function(e) {
	return e > 0 ? _r(gr(e), 9007199254740991) : 0;
}, yr = vr, br = function(e) {
	return yr(e.length);
}, xr = T, Sr = hr, Cr = br, wr = function(e) {
	return function(t, n, r) {
		var i = xr(t), a = Cr(i), o = Sr(r, a), s;
		if (e && n !== n) {
			for (; a > o;) if (s = i[o++], s !== s) return !0;
		} else for (; a > o; o++) if ((e || o in i) && i[o] === n) return e || o || 0;
		return !e && -1;
	};
}, Tr = {
	includes: wr(!0),
	indexOf: wr(!1)
}, Er = L, Dr = Tr.includes;
Er({
	target: "Array",
	proto: !0,
	forced: a(function() {
		return ![,].includes();
	})
}, { includes: function(e) {
	return Dr(this, e, arguments.length > 1 ? arguments[1] : void 0);
} });
var Or = D, kr = function(e) {
	return Or[e + "Prototype"];
}, Ar = kr("Array").includes, jr = E, Mr = b, Nr = j("match"), Pr = function(e) {
	var t;
	return jr(e) && ((t = e[Nr]) === void 0 ? Mr(e) === "RegExp" : !!t);
}, Fr = TypeError, Ir = function(e) {
	if (Pr(e)) throw Fr("The method doesn't accept regular expressions");
	return e;
}, Lr = j("toStringTag"), Rr = {};
Rr[Lr] = "z";
var zr = String(Rr) === "[object z]", Br = zr, Vr = x, Hr = b, Ur = j("toStringTag"), Wr = Object, Gr = Hr(function() {
	return arguments;
}()) === "Arguments", Kr = function(e, t) {
	try {
		return e[t];
	} catch {}
}, qr = Br ? Hr : function(e) {
	var t, n, r;
	return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (n = Kr(t = Wr(e), Ur)) == "string" ? n : Gr ? Hr(t) : (r = Hr(t)) === "Object" && Vr(t.callee) ? "Arguments" : r;
}, Jr = qr, Yr = String, Xr = function(e) {
	if (Jr(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
	return Yr(e);
}, Zr = j("match"), Qr = function(e) {
	var t = /./;
	try {
		"/./"[e](t);
	} catch {
		try {
			return t[Zr] = !1, "/./"[e](t);
		} catch {}
	}
	return !1;
}, $r = L, ei = d, ti = Ir, ni = Te, ri = Xr, ii = Qr, ai = ei("".indexOf);
$r({
	target: "String",
	proto: !0,
	forced: !ii("includes")
}, { includes: function(e) {
	return !!~ai(ri(ni(this)), ri(ti(e)), arguments.length > 1 ? arguments[1] : void 0);
} });
var oi = kr("String").includes, si = f, ci = Ar, li = oi, ui = Array.prototype, di = String.prototype, fi = /*@__PURE__*/ i(function(e) {
	var t = e.includes;
	return e === ui || si(ui, e) && t === ui.includes ? ci : typeof e == "string" || e === di || si(di, e) && t === di.includes ? li : t;
}), pi = b, mi = Array.isArray || function(e) {
	return pi(e) === "Array";
}, hi = d, gi = x, _i = Ct, vi = hi(Function.toString);
gi(_i.inspectSource) || (_i.inspectSource = function(e) {
	return vi(e);
});
var yi = _i.inspectSource, bi = d, xi = a, Si = x, Ci = qr, wi = Fe, Ti = yi, Ei = function() {}, Di = [], Oi = wi("Reflect", "construct"), ki = /^\s*(?:class|function)\b/, Ai = bi(ki.exec), ji = !ki.exec(Ei), Mi = function(e) {
	if (!Si(e)) return !1;
	try {
		return Oi(Ei, Di, e), !0;
	} catch {
		return !1;
	}
}, Ni = function(e) {
	if (!Si(e)) return !1;
	switch (Ci(e)) {
		case "AsyncFunction":
		case "GeneratorFunction":
		case "AsyncGeneratorFunction": return !1;
	}
	try {
		return ji || !!Ai(ki, Ti(e));
	} catch {
		return !0;
	}
};
Ni.sham = !0;
var Pi = !Oi || xi(function() {
	var e;
	return Mi(Mi.call) || !Mi(Object) || !Mi(function() {
		e = !0;
	}) || e;
}) ? Ni : Mi, Fi = mi, Ii = Pi, Li = E, Ri = j("species"), zi = Array, Bi = function(e) {
	var t;
	return Fi(e) && (t = e.constructor, Ii(t) && (t === zi || Fi(t.prototype)) ? t = void 0 : Li(t) && (t = t[Ri], t === null && (t = void 0))), t === void 0 ? zi : t;
}, Vi = function(e, t) {
	return new (Bi(e))(t === 0 ? 0 : t);
}, Hi = Pn, Ui = d, Wi = Se, Gi = Ot, Ki = br, qi = Vi, Ji = Ui([].push), Yi = function(e) {
	var t = e === 1, n = e === 2, r = e === 3, i = e === 4, a = e === 6, o = e === 7, s = e === 5 || a;
	return function(c, l, u, d) {
		for (var f = Gi(c), p = Wi(f), m = Hi(l, u), h = Ki(p), g = 0, _ = d || qi, v = t ? _(c, h) : n || o ? _(c, 0) : void 0, y, ee; h > g; g++) if ((s || g in p) && (y = p[g], ee = m(y, g, f), e)) if (t) v[g] = ee;
		else if (ee) switch (e) {
			case 3: return !0;
			case 5: return y;
			case 6: return g;
			case 2: Ji(v, y);
		}
		else switch (e) {
			case 4: return !1;
			case 7: Ji(v, y);
		}
		return a ? -1 : r || i ? i : v;
	};
}, Xi = {
	forEach: Yi(0),
	map: Yi(1),
	find: Yi(5)
}, Zi = L, Qi = Xi.find, $i = "find", ea = !0;
$i in [] && [,][$i](function() {
	ea = !1;
}), Zi({
	target: "Array",
	proto: !0,
	forced: ea
}, { find: function(e) {
	return Qi(this, e, arguments.length > 1 ? arguments[1] : void 0);
} });
var ta = kr("Array").find, na = f, ra = ta, ia = Array.prototype, aa = /*@__PURE__*/ i(function(e) {
	var t = e.find;
	return e === ia || na(ia, e) && t === ia.find ? ra : t;
}), oa = L, sa = ae, ca = vr, la = Xr, ua = Ir, da = Te, fa = Qr, pa = sa("".startsWith), ma = sa("".slice), ha = Math.min;
oa({
	target: "String",
	proto: !0,
	forced: !fa("startsWith")
}, { startsWith: function(e) {
	var t = la(da(this));
	ua(e);
	var n = ca(ha(arguments.length > 1 ? arguments[1] : void 0, t.length)), r = la(e);
	return pa ? pa(t, r, n) : ma(t, n, n + r.length) === r;
} });
var ga = kr("String").startsWith, _a = f, va = ga, ya = String.prototype, ba = /*@__PURE__*/ i(function(e) {
	var t = e.startsWith;
	return typeof e == "string" || e === ya || _a(ya, e) && t === ya.startsWith ? va : t;
}), R = {}, xa = m, Sa = x, Ca = xa.WeakMap, wa = Sa(Ca) && /native code/.test(String(Ca)), Ta = Tt, Ea = It, Da = Ta("keys"), Oa = function(e) {
	return Da[e] || (Da[e] = Ea(e));
}, ka = {}, Aa = wa, ja = m, Ma = E, Na = P, Pa = k, Fa = Ct, Ia = Oa, La = ka, Ra = "Object already initialized", za = ja.TypeError, Ba = ja.WeakMap, Va, Ha, Ua, Wa = function(e) {
	return Ua(e) ? Ha(e) : Va(e, {});
}, Ga = function(e) {
	return function(t) {
		var n;
		if (!Ma(t) || (n = Ha(t)).type !== e) throw za("Incompatible receiver, " + e + " required");
		return n;
	};
};
if (Aa || Fa.state) {
	var z = Fa.state ||= new Ba();
	z.get = z.get, z.has = z.has, z.set = z.set, Va = function(e, t) {
		if (z.has(e)) throw za(Ra);
		return t.facade = e, z.set(e, t), t;
	}, Ha = function(e) {
		return z.get(e) || {};
	}, Ua = function(e) {
		return z.has(e);
	};
} else {
	var B = Ia("state");
	La[B] = !0, Va = function(e, t) {
		if (Pa(e, B)) throw za(Ra);
		return t.facade = e, Na(e, B, t), t;
	}, Ha = function(e) {
		return Pa(e, B) ? e[B] : {};
	}, Ua = function(e) {
		return Pa(e, B);
	};
}
var Ka = {
	set: Va,
	get: Ha,
	has: Ua,
	enforce: Wa,
	getterFor: Ga
}, qa = S, Ja = k, Ya = Function.prototype, Xa = qa && Object.getOwnPropertyDescriptor, Za = Ja(Ya, "name"), Qa = {
	PROPER: Za && (function() {}).name === "something",
	CONFIGURABLE: Za && (!qa || qa && Xa(Ya, "name").configurable)
}, $a = {}, eo = d, to = k, no = T, ro = Tr.indexOf, io = ka, ao = eo([].push), oo = function(e, t) {
	var n = no(e), r = 0, i = [], a;
	for (a in n) !to(io, a) && to(n, a) && ao(i, a);
	for (; t.length > r;) to(n, a = t[r++]) && (~ro(i, a) || ao(i, a));
	return i;
}, so = [
	"constructor",
	"hasOwnProperty",
	"isPrototypeOf",
	"propertyIsEnumerable",
	"toLocaleString",
	"toString",
	"valueOf"
], co = oo, lo = so, uo = Object.keys || function(e) {
	return co(e, lo);
}, fo = S, po = Fn, mo = M, ho = N, go = T, _o = uo;
$a.f = fo && !po ? Object.defineProperties : function(e, t) {
	ho(e);
	for (var n = go(t), r = _o(t), i = r.length, a = 0, o; i > a;) mo.f(e, o = r[a++], n[o]);
	return e;
};
var vo = Fe("document", "documentElement"), yo = N, bo = $a, xo = so, So = ka, Co = vo, wo = sn, To = Oa, Eo = ">", Do = "<", Oo = "prototype", ko = "script", Ao = To("IE_PROTO"), jo = function() {}, Mo = function(e) {
	return Do + ko + Eo + e + Do + "/" + ko + Eo;
}, No = function(e) {
	e.write(Mo("")), e.close();
	var t = e.parentWindow.Object;
	return e = null, t;
}, Po = function() {
	var e = wo("iframe"), t = "java" + ko + ":", n;
	return e.style.display = "none", Co.appendChild(e), e.src = String(t), n = e.contentWindow.document, n.open(), n.write(Mo("document.F=Object")), n.close(), n.F;
}, Fo, Io = function() {
	try {
		Fo = new ActiveXObject("htmlfile");
	} catch {}
	Io = typeof document < "u" ? document.domain && Fo ? No(Fo) : Po() : No(Fo);
	for (var e = xo.length; e--;) delete Io[Oo][xo[e]];
	return Io();
};
So[Ao] = !0;
var Lo = Object.create || function(e, t) {
	var n;
	return e === null ? n = Io() : (jo[Oo] = yo(e), n = new jo(), jo[Oo] = null, n[Ao] = e), t === void 0 ? n : bo.f(n, t);
}, Ro = !a(function() {
	function e() {}
	return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), zo = k, Bo = x, Vo = Ot, Ho = Oa, Uo = Ro, Wo = Ho("IE_PROTO"), Go = Object, Ko = Go.prototype, qo = Uo ? Go.getPrototypeOf : function(e) {
	var t = Vo(e);
	if (zo(t, Wo)) return t[Wo];
	var n = t.constructor;
	return Bo(n) && t instanceof n ? n.prototype : t instanceof Go ? Ko : null;
}, Jo = P, Yo = function(e, t, n, r) {
	return r && r.enumerable ? e[t] = n : Jo(e, t, n), e;
}, Xo = a, Zo = x, Qo = E, $o = Lo, es = qo, ts = Yo, ns = j("iterator"), rs = !1, V, is, as;
[].keys && (as = [].keys(), "next" in as ? (is = es(es(as)), is !== Object.prototype && (V = is)) : rs = !0), V = !Qo(V) || Xo(function() {
	var e = {};
	return V[ns].call(e) !== e;
}) ? {} : $o(V), Zo(V[ns]) || ts(V, ns, function() {
	return this;
});
var os = {
	IteratorPrototype: V,
	BUGGY_SAFARI_ITERATORS: rs
}, ss = zr, cs = qr, ls = ss ? {}.toString : function() {
	return "[object " + cs(this) + "]";
}, us = zr, ds = M.f, fs = P, ps = k, ms = ls, hs = j("toStringTag"), gs = function(e, t, n, r) {
	if (e) {
		var i = n ? e : e.prototype;
		ps(i, hs) || ds(i, hs, {
			configurable: !0,
			value: t
		}), r && !us && fs(i, "toString", ms);
	}
}, _s = os.IteratorPrototype, vs = Lo, ys = ge, bs = gs, xs = R, Ss = function() {
	return this;
}, Cs = function(e, t, n, r) {
	var i = t + " Iterator";
	return e.prototype = vs(_s, { next: ys(+!r, n) }), bs(e, i, !1, !0), xs[i] = Ss, e;
}, ws = d, Ts = st, Es = function(e, t, n) {
	try {
		return ws(Ts(Object.getOwnPropertyDescriptor(e, t)[n]));
	} catch {}
}, Ds = x, Os = String, ks = TypeError, As = function(e) {
	if (typeof e == "object" || Ds(e)) return e;
	throw ks("Can't set " + Os(e) + " as a prototype");
}, js = Es, Ms = N, Ns = As;
Object.setPrototypeOf || "__proto__" in {} && function() {
	var e = !1, t = {}, n;
	try {
		n = js(Object.prototype, "__proto__", "set"), n(t, []), e = t instanceof Array;
	} catch {}
	return function(t, r) {
		return Ms(t), Ns(r), e ? n(t, r) : t.__proto__ = r, t;
	};
}();
var Ps = L, Fs = C, Is = Qa, Ls = Cs, Rs = qo, zs = gs, Bs = Yo, Vs = j, Hs = R, Us = os, Ws = Is.PROPER;
Is.CONFIGURABLE, Us.IteratorPrototype;
var Gs = Us.BUGGY_SAFARI_ITERATORS, Ks = Vs("iterator"), qs = "keys", Js = "values", Ys = "entries", Xs = function() {
	return this;
}, Zs = function(e, t, n, r, i, a, o) {
	Ls(n, t, r);
	var s = function(e) {
		if (e === i && f) return f;
		if (!Gs && e in u) return u[e];
		switch (e) {
			case qs: return function() {
				return new n(this, e);
			};
			case Js: return function() {
				return new n(this, e);
			};
			case Ys: return function() {
				return new n(this, e);
			};
		}
		return function() {
			return new n(this);
		};
	}, c = t + " Iterator", l = !1, u = e.prototype, d = u[Ks] || u["@@iterator"] || i && u[i], f = !Gs && d || s(i), p = t === "Array" && u.entries || d, m, h, g;
	if (p && (m = Rs(p.call(new e())), m !== Object.prototype && m.next && (zs(m, c, !0, !0), Hs[c] = Xs)), Ws && i === Js && d && d.name !== Js && (l = !0, f = function() {
		return Fs(d, this);
	}), i) if (h = {
		values: s(Js),
		keys: a ? f : s(qs),
		entries: s(Ys)
	}, o) for (g in h) (Gs || l || !(g in u)) && Bs(u, g, h[g]);
	else Ps({
		target: t,
		proto: !0,
		forced: Gs || l
	}, h);
	return o && u[Ks] !== f && Bs(u, Ks, f, {}), Hs[t] = f, h;
}, Qs = function(e, t) {
	return {
		value: e,
		done: t
	};
}, $s = T, ec = R, tc = Ka;
M.f;
var nc = Zs, rc = Qs, ic = "Array Iterator", ac = tc.set, oc = tc.getterFor(ic);
nc(Array, "Array", function(e, t) {
	ac(this, {
		type: ic,
		target: $s(e),
		index: 0,
		kind: t
	});
}, function() {
	var e = oc(this), t = e.target, n = e.kind, r = e.index++;
	if (!t || r >= t.length) return e.target = void 0, rc(void 0, !0);
	switch (n) {
		case "keys": return rc(r, !1);
		case "values": return rc(t[r], !1);
	}
	return rc([r, t[r]], !1);
}, "values"), ec.Arguments = ec.Array;
var sc = j, cc = R, lc = sc("iterator"), uc = Array.prototype, dc = function(e) {
	return e !== void 0 && (cc.Array === e || uc[lc] === e);
}, fc = qr, pc = ut, mc = w, hc = R, gc = j("iterator"), _c = function(e) {
	if (!mc(e)) return pc(e, gc) || pc(e, "@@iterator") || hc[fc(e)];
}, vc = C, yc = st, bc = N, xc = rt, Sc = _c, Cc = TypeError, wc = function(e, t) {
	var n = arguments.length < 2 ? Sc(e) : t;
	if (yc(n)) return bc(vc(n, e));
	throw Cc(xc(e) + " is not iterable");
}, Tc = C, Ec = N, Dc = ut, Oc = function(e, t, n) {
	var r, i;
	Ec(e);
	try {
		if (r = Dc(e, "return"), !r) {
			if (t === "throw") throw n;
			return n;
		}
		r = Tc(r, e);
	} catch (e) {
		i = !0, r = e;
	}
	if (t === "throw") throw n;
	if (i) throw r;
	return Ec(r), n;
}, kc = Pn, Ac = C, jc = N, Mc = rt, Nc = dc, Pc = br, Fc = f, Ic = wc, Lc = _c, Rc = Oc, zc = TypeError, Bc = function(e, t) {
	this.stopped = e, this.result = t;
}, Vc = Bc.prototype, Hc = function(e, t, n) {
	var r = n && n.that, i = !!(n && n.AS_ENTRIES), a = !!(n && n.IS_RECORD), o = !!(n && n.IS_ITERATOR), s = !!(n && n.INTERRUPTED), c = kc(t, r), l, u, d, f, p, m, h, g = function(e) {
		return l && Rc(l, "normal", e), new Bc(!0, e);
	}, _ = function(e) {
		return i ? (jc(e), s ? c(e[0], e[1], g) : c(e[0], e[1])) : s ? c(e, g) : c(e);
	};
	if (a) l = e.iterator;
	else if (o) l = e;
	else {
		if (u = Lc(e), !u) throw zc(Mc(e) + " is not iterable");
		if (Nc(u)) {
			for (d = 0, f = Pc(e); f > d; d++) if (p = _(e[d]), p && Fc(Vc, p)) return p;
			return new Bc(!1);
		}
		l = Ic(e, u);
	}
	for (m = a ? e.next : l.next; !(h = Ac(m, l)).done;) {
		try {
			p = _(h.value);
		} catch (e) {
			Rc(l, "throw", e);
		}
		if (typeof p == "object" && p && Fc(Vc, p)) return p;
	}
	return new Bc(!1);
}, Uc = tn, Wc = M, Gc = ge, Kc = function(e, t, n) {
	var r = Uc(t);
	r in e ? Wc.f(e, r, Gc(0, n)) : e[r] = n;
}, qc = L, Jc = Hc, Yc = Kc;
qc({
	target: "Object",
	stat: !0
}, { fromEntries: function(e) {
	var t = {};
	return Jc(e, function(e, n) {
		Yc(t, e, n);
	}, { AS_ENTRIES: !0 }), t;
} });
var Xc = D.Object.fromEntries, Zc = {
	CSSRuleList: 0,
	CSSStyleDeclaration: 0,
	CSSValueList: 0,
	ClientRectList: 0,
	DOMRectList: 0,
	DOMStringList: 0,
	DOMTokenList: 1,
	DataTransferItemList: 0,
	FileList: 0,
	HTMLAllCollection: 0,
	HTMLCollection: 0,
	HTMLFormElement: 0,
	HTMLSelectElement: 0,
	MediaList: 0,
	MimeTypeArray: 0,
	NamedNodeMap: 0,
	NodeList: 1,
	PaintRequestList: 0,
	Plugin: 0,
	PluginArray: 0,
	SVGLengthList: 0,
	SVGNumberList: 0,
	SVGPathSegList: 0,
	SVGPointList: 0,
	SVGStringList: 0,
	SVGTransformList: 0,
	SourceBufferList: 0,
	StyleSheetList: 0,
	TextTrackCueList: 0,
	TextTrackList: 0,
	TouchList: 0
}, Qc = m, $c = qr, el = P, tl = R, nl = j("toStringTag");
for (var rl in Zc) {
	var il = Qc[rl], al = il && il.prototype;
	al && $c(al) !== nl && el(al, nl, rl), tl[rl] = tl.Array;
}
var ol = /*@__PURE__*/ i(Xc), sl = a, cl = j, ll = We, ul = cl("species"), dl = function(e) {
	return ll >= 51 || !sl(function() {
		var t = [], n = t.constructor = {};
		return n[ul] = function() {
			return { foo: 1 };
		}, t[e](Boolean).foo !== 1;
	});
}, fl = L, pl = Xi.map;
fl({
	target: "Array",
	proto: !0,
	forced: !dl("map")
}, { map: function(e) {
	return pl(this, e, arguments.length > 1 ? arguments[1] : void 0);
} });
var ml = kr("Array").map, hl = f, gl = ml, _l = Array.prototype, vl = /*@__PURE__*/ i(function(e) {
	var t = e.map;
	return e === _l || hl(_l, e) && t === _l.map ? gl : t;
}), yl = { exports: {} }, bl = {}, xl = oo, Sl = so.concat("length", "prototype");
bl.f = Object.getOwnPropertyNames || function(e) {
	return xl(e, Sl);
};
var Cl = {}, wl = hr, Tl = br, El = Kc, Dl = Array, Ol = Math.max, kl = function(e, t, n) {
	for (var r = Tl(e), i = wl(t, r), a = wl(n === void 0 ? r : n, r), o = Dl(Ol(a - i, 0)), s = 0; i < a; i++, s++) El(o, s, e[i]);
	return o.length = s, o;
}, Al = b, jl = T, Ml = bl.f, Nl = kl, Pl = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], Fl = function(e) {
	try {
		return Ml(e);
	} catch {
		return Nl(Pl);
	}
};
Cl.f = function(e) {
	return Pl && Al(e) === "Window" ? Fl(e) : Ml(jl(e));
};
var Il = a(function() {
	if (typeof ArrayBuffer == "function") {
		var e = /* @__PURE__ */ new ArrayBuffer(8);
		Object.isExtensible(e) && Object.defineProperty(e, "a", { value: 8 });
	}
}), Ll = a, Rl = E, zl = b, Bl = Il, Vl = Object.isExtensible, Hl = Ll(function() {
	Vl(1);
}) || Bl ? function(e) {
	return !Rl(e) || Bl && zl(e) === "ArrayBuffer" ? !1 : !Vl || Vl(e);
} : Vl, Ul = !a(function() {
	return Object.isExtensible(Object.preventExtensions({}));
}), Wl = L, Gl = d, Kl = ka, ql = E, Jl = k, Yl = M.f, Xl = bl, Zl = Cl, Ql = Hl, $l = It, eu = Ul, tu = !1, H = $l("meta"), nu = 0, ru = function(e) {
	Yl(e, H, { value: {
		objectID: "O" + nu++,
		weakData: {}
	} });
}, iu = yl.exports = {
	enable: function() {
		iu.enable = function() {}, tu = !0;
		var e = Xl.f, t = Gl([].splice), n = {};
		n[H] = 1, e(n).length && (Xl.f = function(n) {
			for (var r = e(n), i = 0, a = r.length; i < a; i++) if (r[i] === H) {
				t(r, i, 1);
				break;
			}
			return r;
		}, Wl({
			target: "Object",
			stat: !0,
			forced: !0
		}, { getOwnPropertyNames: Zl.f }));
	},
	fastKey: function(e, t) {
		if (!ql(e)) return typeof e == "symbol" ? e : (typeof e == "string" ? "S" : "P") + e;
		if (!Jl(e, H)) {
			if (!Ql(e)) return "F";
			if (!t) return "E";
			ru(e);
		}
		return e[H].objectID;
	},
	getWeakData: function(e, t) {
		if (!Jl(e, H)) {
			if (!Ql(e)) return !0;
			if (!t) return !1;
			ru(e);
		}
		return e[H].weakData;
	},
	onFreeze: function(e) {
		return eu && tu && Ql(e) && !Jl(e, H) && ru(e), e;
	}
};
Kl[H] = !0;
var au = yl.exports, ou = f, su = TypeError, cu = function(e, t) {
	if (ou(t, e)) return e;
	throw su("Incorrect invocation");
}, lu = L, uu = m, du = au, fu = a, pu = P, mu = Hc, hu = cu, gu = x, _u = E, vu = w, yu = gs, bu = M.f, xu = Xi.forEach, Su = S, Cu = Ka, wu = Cu.set, Tu = Cu.getterFor, Eu = function(e, t, n) {
	var r = e.indexOf("Map") !== -1, i = e.indexOf("Weak") !== -1, a = r ? "set" : "add", o = uu[e], s = o && o.prototype, c = {}, l;
	if (!Su || !gu(o) || !(i || s.forEach && !fu(function() {
		new o().entries().next();
	}))) l = n.getConstructor(t, e, r, a), du.enable();
	else {
		l = t(function(t, n) {
			wu(hu(t, u), {
				type: e,
				collection: new o()
			}), vu(n) || mu(n, t[a], {
				that: t,
				AS_ENTRIES: r
			});
		});
		var u = l.prototype, d = Tu(e);
		xu([
			"add",
			"clear",
			"delete",
			"forEach",
			"get",
			"has",
			"set",
			"keys",
			"values",
			"entries"
		], function(e) {
			var t = e === "add" || e === "set";
			e in s && !(i && e === "clear") && pu(u, e, function(n, r) {
				var a = d(this).collection;
				if (!t && i && !_u(n)) return e === "get" && void 0;
				var o = a[e](n === 0 ? 0 : n, r);
				return t ? this : o;
			});
		}), i || bu(u, "size", {
			configurable: !0,
			get: function() {
				return d(this).collection.size;
			}
		});
	}
	return yu(l, e, !1, !0), c[e] = l, lu({
		global: !0,
		forced: !0
	}, c), i || n.setStrong(l, e, r), l;
}, Du = M, Ou = function(e, t, n) {
	return Du.f(e, t, n);
}, ku = Yo, Au = function(e, t, n) {
	for (var r in t) n && n.unsafe && e[r] ? e[r] = t[r] : ku(e, r, t[r], n);
	return e;
}, ju = Fe, Mu = Ou, Nu = j, Pu = S, Fu = Nu("species"), Iu = function(e) {
	var t = ju(e);
	Pu && t && !t[Fu] && Mu(t, Fu, {
		configurable: !0,
		get: function() {
			return this;
		}
	});
}, Lu = Lo, Ru = Ou, zu = Au, Bu = Pn, Vu = cu, Hu = w, Uu = Hc, Wu = Zs, Gu = Qs, Ku = Iu, qu = S, Ju = au.fastKey, Yu = Ka, Xu = Yu.set, Zu = Yu.getterFor;
Eu("Set", function(e) {
	return function() {
		return e(this, arguments.length ? arguments[0] : void 0);
	};
}, {
	getConstructor: function(e, t, n, r) {
		var i = e(function(e, i) {
			Vu(e, a), Xu(e, {
				type: t,
				index: Lu(null),
				first: void 0,
				last: void 0,
				size: 0
			}), qu || (e.size = 0), Hu(i) || Uu(i, e[r], {
				that: e,
				AS_ENTRIES: n
			});
		}), a = i.prototype, o = Zu(t), s = function(e, t, n) {
			var r = o(e), i = c(e, t), a, s;
			return i ? i.value = n : (r.last = i = {
				index: s = Ju(t, !0),
				key: t,
				value: n,
				previous: a = r.last,
				next: void 0,
				removed: !1
			}, r.first ||= i, a && (a.next = i), qu ? r.size++ : e.size++, s !== "F" && (r.index[s] = i)), e;
		}, c = function(e, t) {
			var n = o(e), r = Ju(t), i;
			if (r !== "F") return n.index[r];
			for (i = n.first; i; i = i.next) if (i.key === t) return i;
		};
		return zu(a, {
			clear: function() {
				for (var e = this, t = o(e), n = t.index, r = t.first; r;) r.removed = !0, r.previous &&= r.previous.next = void 0, delete n[r.index], r = r.next;
				t.first = t.last = void 0, qu ? t.size = 0 : e.size = 0;
			},
			delete: function(e) {
				var t = this, n = o(t), r = c(t, e);
				if (r) {
					var i = r.next, a = r.previous;
					delete n.index[r.index], r.removed = !0, a && (a.next = i), i && (i.previous = a), n.first === r && (n.first = i), n.last === r && (n.last = a), qu ? n.size-- : t.size--;
				}
				return !!r;
			},
			forEach: function(e) {
				for (var t = o(this), n = Bu(e, arguments.length > 1 ? arguments[1] : void 0), r; r = r ? r.next : t.first;) for (n(r.value, r.key, this); r && r.removed;) r = r.previous;
			},
			has: function(e) {
				return !!c(this, e);
			}
		}), zu(a, n ? {
			get: function(e) {
				var t = c(this, e);
				return t && t.value;
			},
			set: function(e, t) {
				return s(this, e === 0 ? 0 : e, t);
			}
		} : { add: function(e) {
			return s(this, e = e === 0 ? 0 : e, e);
		} }), qu && Ru(a, "size", {
			configurable: !0,
			get: function() {
				return o(this).size;
			}
		}), i;
	},
	setStrong: function(e, t, n) {
		var r = t + " Iterator", i = Zu(t), a = Zu(r);
		Wu(e, t, function(e, t) {
			Xu(this, {
				type: r,
				target: e,
				state: i(e),
				kind: t,
				last: void 0
			});
		}, function() {
			for (var e = a(this), t = e.kind, n = e.last; n && n.removed;) n = n.previous;
			return !e.target || !(e.last = n = n ? n.next : e.state.first) ? (e.target = void 0, Gu(void 0, !0)) : Gu(t === "keys" ? n.key : t === "values" ? n.value : [n.key, n.value], !1);
		}, n ? "entries" : "values", !n, !0), Ku(t);
	}
});
var Qu = d, $u = dr, ed = Xr, td = Te, nd = Qu("".charAt), rd = Qu("".charCodeAt), id = Qu("".slice), ad = { charAt: function(e) {
	return function(t, n) {
		var r = ed(td(t)), i = $u(n), a = r.length, o, s;
		return i < 0 || i >= a ? e ? "" : void 0 : (o = rd(r, i), o < 55296 || o > 56319 || i + 1 === a || (s = rd(r, i + 1)) < 56320 || s > 57343 ? e ? nd(r, i) : o : e ? id(r, i, i + 2) : (o - 55296 << 10) + (s - 56320) + 65536);
	};
}(!0) }.charAt, od = Xr, sd = Ka, cd = Zs, ld = Qs, ud = "String Iterator", dd = sd.set, fd = sd.getterFor(ud);
cd(String, "String", function(e) {
	dd(this, {
		type: ud,
		string: od(e),
		index: 0
	});
}, function() {
	var e = fd(this), t = e.string, n = e.index, r;
	return n >= t.length ? ld(void 0, !0) : (r = ad(t, n), e.index += r.length, ld(r, !1));
});
var pd = D.Set, md = /*@__PURE__*/ i(pd), hd = S, gd = a, _d = d, vd = qo, yd = uo, bd = T, xd = pe.f, Sd = _d(xd), Cd = _d([].push), wd = hd && gd(function() {
	var e = Object.create(null);
	return e[2] = 2, !Sd(e, 2);
}), Td = function(e) {
	return function(t) {
		for (var n = bd(t), r = yd(n), i = wd && vd(n) === null, a = r.length, o = 0, s = [], c; a > o;) c = r[o++], (!hd || (i ? c in n : Sd(n, c))) && Cd(s, e ? [c, n[c]] : n[c]);
		return s;
	};
}, Ed = {
	entries: Td(!0),
	values: Td(!1)
}, Dd = L, Od = Ed.values;
Dd({
	target: "Object",
	stat: !0
}, { values: function(e) {
	return Od(e);
} });
var kd = D.Object.values, Ad = /*@__PURE__*/ i(kd), jd = L, Md = Ed.entries;
jd({
	target: "Object",
	stat: !0
}, { entries: function(e) {
	return Md(e);
} });
var Nd = D.Object.entries, Pd = /*@__PURE__*/ i(Nd), Fd = [
	"prod",
	"stag",
	"stag2",
	"dev1",
	"preprod"
], Id = ol(vl(Fd).call(Fd, (e) => [e, e === "prod" ? "dixa.io" : `euw1.${e}.dixa.io`]));
function Ld(e) {
	return new md(Ad(Id)).has(e);
}
function Rd(e) {
	if (!e) return "prod";
	for (let [t, n] of Pd(Id)) if (e === n) return t;
	return "prod";
}
function zd(e) {
	e = e.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
	let t = RegExp(`[\\?&]${e}=([^&#]*)`).exec(location.search);
	return t === null ? null : Bd(t[1].replace(/\+/g, " "));
}
function Bd(e) {
	try {
		return decodeURIComponent(e);
	} catch {
		return console.warn(`Failed to decode param value '${e}'`), e;
	}
}
var Vd = { backendDomain: "dixa:backend-domain" };
function Hd() {
	let e = zd("staging") || zd("backend-domain");
	if (e) {
		let t = /^\d+$/.test(e) ? `euw1.stag${e === "1" ? "" : e}.dixa.io` : e;
		return Ld(t) ? (Wd(t), t) : null;
	}
	return null;
}
function Ud() {
	var e;
	let t = aa(e = document.cookie.split("; ")).call(e, (e) => ba(e).call(e, `${Vd.backendDomain}=`)), n = t ? decodeURIComponent(t.split("=")[1]) : null;
	return n && !Ld(n) ? (Gd(), null) : n;
}
function Wd(e) {
	document.cookie = `${Vd.backendDomain}=${encodeURIComponent(e)}; path=/; max-age=31536000; SameSite=Lax`;
}
function Gd() {
	document.cookie = `${Vd.backendDomain}=; path=/; max-age=0`;
}
var Kd, qd, Jd, Yd, Xd = window.location.origin.replace(/^https?:\/\//, ""), U = Hd() ?? Ud(), W = Rd(U), G = {
	develop: [
		"localhost:8080",
		"dixadev.com",
		"dixa.io"
	],
	test: {
		security: ["dixa-security.com", "dixa-security.net"],
		automation: [
			"localhost:9999",
			"test-agent-interface.dixa.io",
			"test.dixatest.com",
			"okta-test-org.dixatest.com"
		]
	},
	custom: [
		"thehaddaway.dixa.com",
		"demo.dixa.com",
		"developer.dixa.com",
		"okta-test.dixa.com",
		"development.dixa.com",
		"engineering.dixa.com"
	],
	default: {
		email: "dixa.com",
		emailIntegration: "email.dixa.io",
		integrations: "docs.dixa.io",
		service: "dixa.io",
		status: "status.dixa.io",
		subdomain: "demo",
		userContent: "dixausercontent.com",
		web: "dixa.com",
		accounts: "accounts.dixa.com",
		knowledge: "knowledge-backend-cdn",
		satisfactionSurveyPreview: "csat.reviews"
	}
}, Zd = {
	assets: `https://assets.${G.default.service}`,
	toolkit: `https://toolkit.${G.default.service}`,
	widget: `https://widget.${G.default.service}`,
	messenger: W === "prod" ? `https://messenger.${G.default.service}` : `https://messenger.${W}.${G.default.service}`,
	rest: `https://api.${U ?? G.default.service}`,
	advancedInsights: `https://api.${U ?? G.default.service}/v1/advanced-insights/`,
	partnerIntegrations: `https://partner-integrations.${U ?? G.default.service}`,
	files: `https://files.${U ?? G.default.service}`,
	webSocket: `wss://agent-sockets.${U ?? G.default.service}/v2/agent/`,
	userContent: U ? `https://raw.${U.replace(G.default.service, G.default.userContent)}` : `https://raw.${G.default.userContent}`,
	signUp: `https://${G.default.accounts}/signup`,
	logIn: `https://${G.default.accounts}/signin`,
	knowledgeCdn: W === "prod" ? `https://knowledge-backend-cdn.${G.default.service}` : `https://knowledge-backend-cdn.${W}.${G.default.service}`,
	knowledgeApi: `https://knowledge-backend.${U ?? G.default.service}`,
	satisfactionSurveyPreview: W === "prod" ? `https://${G.default.satisfactionSurveyPreview}/preview.html` : `https://stag.${G.default.satisfactionSurveyPreview}/preview.html`
}, Qd = {
	amplitude: { environment: fi(Kd = [
		...G.test.automation,
		...G.develop,
		...G.test.security,
		...G.custom
	]).call(Kd, Xd) || W !== "prod" ? "stag" : "prod" },
	launchDarkly: fi(qd = G.develop).call(qd, Xd) ? "5ccbf1bfa9046808225e3998" : "5ccbf1bfa9046808225e3999",
	stripe: fi(Jd = G.develop).call(Jd, Xd) ? "pk_test_jNReMBzv4cyXIBkSUrqaFtd0" : "pk_live_0b40LYRePjPZTtN9E9NbKixl",
	elevio: "599d54aacd7bd",
	birdeatsbug: "eee2fdfc-e7ee-4698-95fd-20e8cb83a4d5",
	jabra: {
		partnerKey: "4d2f-9cba7bbd-a9dd-4703-9847-c70a7df516ba",
		appId: "Dixa",
		appName: "Dixa"
	},
	messenger: { token: {
		prod: fi(Yd = G.develop).call(Yd, Xd) ? "95b2b555c0b046a18e5d508837811008" : "7c08132d4bf5d5f1bf4432133ef8254e3262f9ef",
		stag: "0a76a5650f3540dc8bad030e54aa2e22",
		stag2: "0a76a5650f3540dc8bad030e54aa2e22",
		dev1: "414a01b7802f4d4bb61a6ab6aaacd442",
		preprod: ""
	} }
}, $d = {
	environment: W,
	domain: G.default,
	sdk: Qd,
	url: Zd,
	backendDomain: U
}, ef = new class {
	isElectron() {
		return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
	}
	async getVersion() {
		return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
	}
	async isStandaloneBuild() {
		return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
	}
	async isMsiBuild() {
		return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
	}
}();
//#endregion
//#region ../semver/dist/index.es.js
function tf(e, t) {
	return nf(e), nf(t), e.localeCompare(t, void 0, { numeric: !0 });
}
function nf(e) {
	if (e.split(".").length !== 3) throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/is.js
var rf = Object.prototype.toString;
function af(e, t) {
	return rf.call(e) === `[object ${t}]`;
}
function of(e) {
	return af(e, "Object");
}
function sf(e) {
	return !!(e && e.then && typeof e.then == "function");
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/version.js
var cf = "8.36.0", K = globalThis;
function lf(e, t, n) {
	let r = n || K, i = r.__SENTRY__ = r.__SENTRY__ || {}, a = i[cf] = i["8.36.0"] || {};
	return a[e] || (a[e] = t());
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/debug-build.js
var uf = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, df = "Sentry Logger ", ff = [
	"debug",
	"info",
	"warn",
	"error",
	"log",
	"assert",
	"trace"
], pf = {};
function mf(e) {
	if (!("console" in K)) return e();
	let t = K.console, n = {}, r = Object.keys(pf);
	r.forEach((e) => {
		let r = pf[e];
		n[e] = t[e], t[e] = r;
	});
	try {
		return e();
	} finally {
		r.forEach((e) => {
			t[e] = n[e];
		});
	}
}
function hf() {
	let e = !1, t = {
		enable: () => {
			e = !0;
		},
		disable: () => {
			e = !1;
		},
		isEnabled: () => e
	};
	return uf ? ff.forEach((n) => {
		t[n] = (...t) => {
			e && mf(() => {
				K.console[n](`${df}[${n}]:`, ...t);
			});
		};
	}) : ff.forEach((e) => {
		t[e] = () => void 0;
	}), t;
}
var gf = lf("logger", hf);
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/object.js
function _f(e, t, n) {
	try {
		Object.defineProperty(e, t, {
			value: n,
			writable: !0,
			configurable: !0
		});
	} catch {
		uf && gf.log(`Failed to add non-enumerable property "${t}" to object`, e);
	}
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/time.js
var vf = 1e3;
function yf() {
	return Date.now() / vf;
}
function bf() {
	let { performance: e } = K;
	if (!e || !e.now) return yf;
	let t = Date.now() - e.now(), n = e.timeOrigin == null ? t : e.timeOrigin;
	return () => (n + e.now()) / vf;
}
var xf = bf();
(() => {
	let { performance: e } = K;
	if (!e || !e.now) return;
	let t = 3600 * 1e3, n = e.now(), r = Date.now(), i = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, a = i < t, o = e.timing && e.timing.navigationStart, s = typeof o == "number" ? Math.abs(o + n - r) : t;
	return a || s < t ? i <= s ? e.timeOrigin : o : r;
})();
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/misc.js
function q() {
	let e = K, t = e.crypto || e.msCrypto, n = () => Math.random() * 16;
	try {
		if (t && t.randomUUID) return t.randomUUID().replace(/-/g, "");
		t && t.getRandomValues && (n = () => {
			let e = /* @__PURE__ */ new Uint8Array(1);
			return t.getRandomValues(e), e[0];
		});
	} catch {}
	return "10000000100040008000100000000000".replace(/[018]/g, (e) => (e ^ (n() & 15) >> e / 4).toString(16));
}
//#endregion
//#region ../../../node_modules/@sentry/utils/build/esm/propagationContext.js
function Sf() {
	return {
		traceId: q(),
		spanId: q().substring(16)
	};
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/carrier.js
function Cf() {
	return wf(K), K;
}
function wf(e) {
	let t = e.__SENTRY__ = e.__SENTRY__ || {};
	return t.version = t.version || "8.36.0", t[cf] = t["8.36.0"] || {};
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/session.js
function Tf(e, t = {}) {
	if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || xf(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : q()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration) e.duration = void 0;
	else if (typeof t.duration == "number") e.duration = t.duration;
	else {
		let t = e.timestamp - e.started;
		e.duration = t >= 0 ? t : 0;
	}
	t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var Ef = "_sentrySpan";
function Df(e, t) {
	t ? _f(e, Ef, t) : delete e[Ef];
}
function Of(e) {
	return e[Ef];
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/scope.js
var kf = 100, J = class e {
	constructor() {
		this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Sf();
	}
	clone() {
		let t = new e();
		return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._requestSession = this._requestSession, t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, Df(t, Of(this)), t;
	}
	setClient(e) {
		this._client = e;
	}
	setLastEventId(e) {
		this._lastEventId = e;
	}
	getClient() {
		return this._client;
	}
	lastEventId() {
		return this._lastEventId;
	}
	addScopeListener(e) {
		this._scopeListeners.push(e);
	}
	addEventProcessor(e) {
		return this._eventProcessors.push(e), this;
	}
	setUser(e) {
		return this._user = e || {
			email: void 0,
			id: void 0,
			ip_address: void 0,
			username: void 0
		}, this._session && Tf(this._session, { user: e }), this._notifyScopeListeners(), this;
	}
	getUser() {
		return this._user;
	}
	getRequestSession() {
		return this._requestSession;
	}
	setRequestSession(e) {
		return this._requestSession = e, this;
	}
	setTags(e) {
		return this._tags = {
			...this._tags,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setTag(e, t) {
		return this._tags = {
			...this._tags,
			[e]: t
		}, this._notifyScopeListeners(), this;
	}
	setExtras(e) {
		return this._extra = {
			...this._extra,
			...e
		}, this._notifyScopeListeners(), this;
	}
	setExtra(e, t) {
		return this._extra = {
			...this._extra,
			[e]: t
		}, this._notifyScopeListeners(), this;
	}
	setFingerprint(e) {
		return this._fingerprint = e, this._notifyScopeListeners(), this;
	}
	setLevel(e) {
		return this._level = e, this._notifyScopeListeners(), this;
	}
	setTransactionName(e) {
		return this._transactionName = e, this._notifyScopeListeners(), this;
	}
	setContext(e, t) {
		return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
	}
	setSession(e) {
		return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
	}
	getSession() {
		return this._session;
	}
	update(e) {
		if (!e) return this;
		let t = typeof e == "function" ? e(this) : e, [n, r] = t instanceof J ? [t.getScopeData(), t.getRequestSession()] : of(t) ? [e, e.requestSession] : [], { tags: i, extra: a, user: o, contexts: s, level: c, fingerprint: l = [], propagationContext: u } = n || {};
		return this._tags = {
			...this._tags,
			...i
		}, this._extra = {
			...this._extra,
			...a
		}, this._contexts = {
			...this._contexts,
			...s
		}, o && Object.keys(o).length && (this._user = o), c && (this._level = c), l.length && (this._fingerprint = l), u && (this._propagationContext = u), r && (this._requestSession = r), this;
	}
	clear() {
		return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Df(this, void 0), this._attachments = [], this._propagationContext = Sf(), this._notifyScopeListeners(), this;
	}
	addBreadcrumb(e, t) {
		let n = typeof t == "number" ? t : kf;
		if (n <= 0) return this;
		let r = {
			timestamp: yf(),
			...e
		}, i = this._breadcrumbs;
		return i.push(r), this._breadcrumbs = i.length > n ? i.slice(-n) : i, this._notifyScopeListeners(), this;
	}
	getLastBreadcrumb() {
		return this._breadcrumbs[this._breadcrumbs.length - 1];
	}
	clearBreadcrumbs() {
		return this._breadcrumbs = [], this._notifyScopeListeners(), this;
	}
	addAttachment(e) {
		return this._attachments.push(e), this;
	}
	clearAttachments() {
		return this._attachments = [], this;
	}
	getScopeData() {
		return {
			breadcrumbs: this._breadcrumbs,
			attachments: this._attachments,
			contexts: this._contexts,
			tags: this._tags,
			extra: this._extra,
			user: this._user,
			level: this._level,
			fingerprint: this._fingerprint || [],
			eventProcessors: this._eventProcessors,
			propagationContext: this._propagationContext,
			sdkProcessingMetadata: this._sdkProcessingMetadata,
			transactionName: this._transactionName,
			span: Of(this)
		};
	}
	setSDKProcessingMetadata(e) {
		return this._sdkProcessingMetadata = {
			...this._sdkProcessingMetadata,
			...e
		}, this;
	}
	setPropagationContext(e) {
		return this._propagationContext = e, this;
	}
	getPropagationContext() {
		return this._propagationContext;
	}
	captureException(e, t) {
		let n = t && t.event_id ? t.event_id : q();
		if (!this._client) return gf.warn("No client configured on scope - will not capture exception!"), n;
		let r = /* @__PURE__ */ Error("Sentry syntheticException");
		return this._client.captureException(e, {
			originalException: e,
			syntheticException: r,
			...t,
			event_id: n
		}, this), n;
	}
	captureMessage(e, t, n) {
		let r = n && n.event_id ? n.event_id : q();
		if (!this._client) return gf.warn("No client configured on scope - will not capture message!"), r;
		let i = Error(e);
		return this._client.captureMessage(e, t, {
			originalException: e,
			syntheticException: i,
			...n,
			event_id: r
		}, this), r;
	}
	captureEvent(e, t) {
		let n = t && t.event_id ? t.event_id : q();
		return this._client ? (this._client.captureEvent(e, {
			...t,
			event_id: n
		}, this), n) : (gf.warn("No client configured on scope - will not capture event!"), n);
	}
	_notifyScopeListeners() {
		this._notifyingListeners ||= (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
			e(this);
		}), !1);
	}
};
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/defaultScopes.js
function Af() {
	return lf("defaultCurrentScope", () => new J());
}
function jf() {
	return lf("defaultIsolationScope", () => new J());
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/asyncContext/stackStrategy.js
var Mf = class {
	constructor(e, t) {
		let n;
		n = e || new J();
		let r;
		r = t || new J(), this._stack = [{ scope: n }], this._isolationScope = r;
	}
	withScope(e) {
		let t = this._pushScope(), n;
		try {
			n = e(t);
		} catch (e) {
			throw this._popScope(), e;
		}
		return sf(n) ? n.then((e) => (this._popScope(), e), (e) => {
			throw this._popScope(), e;
		}) : (this._popScope(), n);
	}
	getClient() {
		return this.getStackTop().client;
	}
	getScope() {
		return this.getStackTop().scope;
	}
	getIsolationScope() {
		return this._isolationScope;
	}
	getStackTop() {
		return this._stack[this._stack.length - 1];
	}
	_pushScope() {
		let e = this.getScope().clone();
		return this._stack.push({
			client: this.getClient(),
			scope: e
		}), e;
	}
	_popScope() {
		return this._stack.length <= 1 ? !1 : !!this._stack.pop();
	}
};
function Y() {
	let e = wf(Cf());
	return e.stack = e.stack || new Mf(Af(), jf());
}
function Nf(e) {
	return Y().withScope(e);
}
function Pf(e, t) {
	let n = Y();
	return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function Ff(e) {
	return Y().withScope(() => e(Y().getIsolationScope()));
}
function If() {
	return {
		withIsolationScope: Ff,
		withScope: Nf,
		withSetScope: Pf,
		withSetIsolationScope: (e, t) => Ff(t),
		getCurrentScope: () => Y().getScope(),
		getIsolationScope: () => Y().getIsolationScope()
	};
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/asyncContext/index.js
function Lf(e) {
	let t = wf(e);
	return t.acs ? t.acs : If();
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/currentScopes.js
function Rf() {
	return Lf(Cf()).getCurrentScope();
}
function zf() {
	return Lf(Cf()).getIsolationScope();
}
function Bf() {
	return Rf().getClient();
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/utils/prepareEvent.js
function Vf(e) {
	if (e) return Hf(e) || Wf(e) ? { captureContext: e } : e;
}
function Hf(e) {
	return e instanceof J || typeof e == "function";
}
var Uf = [
	"user",
	"level",
	"extra",
	"contexts",
	"tags",
	"fingerprint",
	"requestSession",
	"propagationContext"
];
function Wf(e) {
	return Object.keys(e).some((e) => Uf.includes(e));
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/exports.js
function Gf(e, t) {
	return Rf().captureException(e, Vf(t));
}
function Kf(e, t) {
	let n = typeof t == "string" ? t : void 0, r = typeof t == "string" ? void 0 : { captureContext: t };
	return Rf().captureMessage(e, n, r);
}
function qf(e, t) {
	zf().setContext(e, t);
}
//#endregion
//#region ../../../node_modules/@sentry/core/build/esm/breadcrumbs.js
var Jf = 100;
function X(e, t) {
	let n = Bf(), r = zf();
	if (!n) return;
	let { beforeBreadcrumb: i = null, maxBreadcrumbs: a = Jf } = n.getOptions();
	if (a <= 0) return;
	let o = {
		timestamp: yf(),
		...e
	}, s = i ? mf(() => i(o, t)) : o;
	s !== null && (n.emit && n.emit("beforeAddBreadcrumb", s, t), r.addBreadcrumb(s, a));
}
//#endregion
//#region ../sentry/dist/index.js
var Yf;
(function(e) {
	e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Yf ||= {});
//#endregion
//#region ../auth/dist/jwt/jwt.js
function Z(e) {
	let t = e.split(".")[1];
	if (!t) throw Error("Invalid token");
	let n = t.replace(/-/g, "+").replace(/_/g, "/");
	try {
		return JSON.parse(Buffer.from(n, "base64").toString());
	} catch (e) {
		throw Error(`Failed to parse the JSON Web Token with the following error: ${e}`);
	}
}
//#endregion
//#region ../auth/dist/redirect/redirect.js
var Xf = $d.backendDomain ? { "backend-domain": $d.backendDomain } : void 0;
function Zf() {
	let e = new URLSearchParams({
		noToken: "true",
		...Xf
	}).toString();
	document.location.href = `${$d.url.logIn}?${e}`;
}
//#endregion
//#region ../auth/dist/authManager/authStorageConfig.js
var Qf = "authData", $f = 600, ep = 5, Q = new class {
	authData = null;
	accessTokenExpiresAt = 0;
	clientServerTimeDiff = 0;
	estimatedServerTime() {
		let e = Date.now() / 1e3;
		return this.clientServerTimeDiff >= ep || this.clientServerTimeDiff <= -5 ? Math.ceil(e + this.clientServerTimeDiff) : Math.ceil(e);
	}
	setAuthData(e) {
		this.authData = e;
		let t = Math.ceil(Date.now() / 1e3) + $f, n = Z(e.access_token).exp;
		if (this.clientServerTimeDiff = n - t, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > ep) {
			let e = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
			console.info(`Client time is ${e} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
		}
		this.accessTokenExpiresAt = n, localStorage.setItem(Qf, JSON.stringify(e));
	}
	getAuthData() {
		if (this.authData) return this.authData;
		let e = localStorage.getItem(Qf), t = e ? JSON.parse(e) : null;
		return this.validateAuthDataComplete(t) && (this.authData = t), t;
	}
	removeAuthData() {
		this.authData = null, localStorage.removeItem(Qf);
	}
	getAccessToken() {
		return this.authData?.access_token || null;
	}
	getRefreshToken() {
		return this.authData?.refresh_token || null;
	}
	validateAuthDataComplete(e) {
		return e ? [
			"access_token",
			"refresh_token",
			"expires_in"
		].every((t) => e[t] !== void 0) : !1;
	}
	isAccessTokenExpired() {
		if (!this.getAccessToken()) return !0;
		let e = this.accessTokenExpiresAt - 30;
		return this.estimatedServerTime() >= e;
	}
	isRefreshTokenExpired(e) {
		if (!e) return !0;
		let t = Z(e), n = t.exp - 30;
		return !t || this.estimatedServerTime() >= n;
	}
	accessTokenExpiresInMs() {
		return (this.accessTokenExpiresAt - 30 - this.estimatedServerTime()) * 1e3;
	}
}();
//#endregion
//#region ../auth/dist/authManager/interceptor.js
async function tp(e) {
	let t = window.location.origin.replace(/^https?:\/\//, "");
	if (!(!e.response || ["localhost:8080", "uptrends-monitor"].some((e) => t.includes(e)))) {
		try {
			let t = e.response.config.headers.Authorization ?? "", n = t ? t.toString()?.split("Basic ")[1] : "", r = n ? atob(n).split("token:")[1] : "", i = r ? Z(r).exp : "None", a = await up.getAuthData({ localStorageOnly: !0 }), o = Math.floor(Date.now() / 1e3), s = a?.access_token, c = a?.refresh_token, l = s ? Z(s).exp : "None", u = c ? Z(c).exp : "None", d = typeof i == "number" ? o - i : "Unknown", f = typeof l == "number" ? o - l : "Unknown", p = typeof u == "number" ? o - u : "Unknown", m = e.response.headers["x-dixa-rid"];
			qf("Expires", {
				currentTimestamp: o,
				accessTokenFromHeader: i,
				accessTokenFromHeaderDiff: d,
				accessTokenFromLocalStorage: l,
				accessTokenFromLocalStorageDiff: f,
				refreshTokenFromLocalStorage: u,
				refreshTokenFromLocalStorageDiff: p,
				xDixaRid: m,
				navigatorOnline: navigator.onLine
			});
		} catch (e) {
			console.error("Error adding Sentry error context", e);
		}
		Kf("401 unauthorized interceptor", {
			level: "debug",
			tags: {
				team: Yf.Platform,
				domain: t
			}
		});
	}
}
var np = /* @__PURE__ */ new Map(), rp = 3;
function ip(e) {
	e.interceptors.response.use((e) => (np.delete(e.config.url), e), (t) => {
		if (t.response) {
			let { status: n } = t.response;
			switch (n) {
				case dp.Unauthorized:
					if (!up.isRefreshTokenExpired() && t.config) {
						X({
							category: "errorInterceptor",
							message: "Access token expired after request",
							level: "debug"
						});
						let n = np.get(t.config.url) ?? 0;
						if (console.log(`Retrying request (${n + 1}): ${t.config.url}`), n <= rp) return np.set(t.config.url, n + 1), e(t.config);
					}
					tp(t), console.error("401 unauthorized interceptor"), Zf();
					break;
			}
		}
		return Promise.reject(t);
	});
}
//#endregion
//#region ../auth/dist/authManager/authManager.js
var ap = e.create();
ip(ap);
var $ = console.log;
async function op(e) {
	return new Promise((t) => setTimeout(t, e * 1e3));
}
var sp = class extends Error {
	constructor(e, t) {
		super(e, t);
	}
};
function cp(e = 0) {
	return Math.min(Math.round((Math.random() + 1) * 1.5 ** e), 30);
}
var lp = 5, up = new class {
	authDataPromise = null;
	retryCount = 0;
	async init(e) {
		let t = await this.refresh(e);
		if (t) Q.setAuthData(t);
		else throw new sp("Failed to init refresh token", { cause: Q.isRefreshTokenExpired(e) ? "expired" : "unknown" });
	}
	getDebugInfo() {
		let e = Q.getAccessToken();
		if (!e) return {};
		let { exp: t } = Z(e);
		return {
			expire: t ? (/* @__PURE__ */ new Date(t * 1e3)).toISOString() : null,
			now: (/* @__PURE__ */ new Date()).toISOString()
		};
	}
	async getAuthData({ localStorageOnly: e = !1 } = {}) {
		if (e) return Q.getAuthData();
		if (this.authDataPromise) return await this.authDataPromise;
		let t = Q.getAuthData();
		return t ? Q.isAccessTokenExpired() ? (X({
			category: "refreshToken",
			message: "expired or about to expire",
			level: "debug",
			data: this.getDebugInfo()
		}), this.authDataPromise = this.refresh(t.refresh_token).then((e) => (e && Q.setAuthData(e), this.authDataPromise = null, e)), await this.authDataPromise) : t : null;
	}
	removeAuthData() {
		return Q.removeAuthData();
	}
	validateAuthDataComplete(e) {
		return Q.validateAuthDataComplete(e);
	}
	isAccessTokenExpired() {
		return Q.isAccessTokenExpired();
	}
	isRefreshTokenExpired() {
		let e = Q.getAuthData();
		return !e || Q.isRefreshTokenExpired(e.refresh_token);
	}
	async isSupported() {
		return !ef.isElectron() || tf(await ef.getVersion(), "3.7.0") === 1;
	}
	async refresh(e, t = lp) {
		try {
			return await ap.post(`${$d.url.rest}/v2/login/refresh`, { refreshToken: e }).then((e) => (this.retryCount = 0, e.data.data));
		} catch (n) {
			return await this.handleRefreshError(n, e, t);
		}
	}
	async waitUntilOnline() {
		let e = navigator.onLine === !1;
		for (e && ($("AUTH", "Network connection offline - waiting..."), X({
			category: "refreshToken",
			message: "Network connection offline - waiting...",
			level: "debug"
		})); navigator.onLine === !1;) await op(5);
		e && ($("AUTH", "Network connection restored"), X({
			category: "refreshToken",
			message: "Network connection restored",
			level: "debug"
		}));
	}
	async retryRefresh(e, t) {
		await this.waitUntilOnline(), this.retryCount++;
		let n = cp(this.retryCount);
		return $("AUTH", `Retrying in ${n} seconds`), await op(n), await this.refresh(e, t);
	}
	async handleRefreshError(e, n, r) {
		if (Q.isRefreshTokenExpired(n)) return $("AUTH", "Refresh token expired"), X({
			category: "refreshToken",
			message: "Refresh token expired",
			level: "debug"
		}), Q.removeAuthData(), Zf(), null;
		if (t(e)) {
			if (e.message === "timeout exceeded") return $("AUTH", "Timeout exceeded"), X({
				category: "refreshToken",
				message: "Timeout exceeded",
				level: "debug"
			}), await this.retryRefresh(n, r);
			if (e.message === "Network Error") return $("AUTH", "Network error"), X({
				category: "refreshToken",
				message: "Network error",
				level: "debug"
			}), await this.retryRefresh(n, r);
			if (e.response?.status === 401) return $("AUTH", "Refresh token invalid (401)"), Q.removeAuthData(), Zf(), null;
			Gf(e, {
				level: "error",
				tags: {
					team: Yf.Platform,
					errorSource: "authManager.refresh"
				}
			});
		}
		return r <= 0 ? ($("AUTH", "Retries exhausted, logging out"), Gf(e, {
			level: "error",
			tags: {
				team: Yf.Platform,
				errorSource: "authManager.refresh"
			}
		}), Q.removeAuthData(), Zf(), null) : ($("AUTH", `Retrying ${r} more times`), await this.retryRefresh(n, r - 1));
	}
	accessTokenExpiresInMs() {
		return Q.accessTokenExpiresInMs();
	}
}(), dp;
(function(e) {
	e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(dp ||= {});
//#endregion
//#region src/accessControl.ts
var fp = e.create(), pp = new class {
	user = null;
	scopes = null;
	_roles = null;
	get isInitialized() {
		return this.user !== null;
	}
	async init({ user: e }) {
		this.user = e;
		let t = await this.introspectAccessToken();
		t && (this.scopes = t.scope, this._roles = t.roles);
	}
	get roles() {
		return this._roles;
	}
	hasAccess(e, t) {
		if (!this.isInitialized || this.scopes === null) return !1;
		if (Array.isArray(e)) {
			let { strategy: n = "all" } = t ?? {};
			return n === "all" ? e.every(this.hasScope) : e.some(this.hasScope);
		}
		return this.scopes.includes(e);
	}
	hasScope = (e) => this.scopes.includes(e);
	async introspectAccessToken() {
		let e = await up.getAuthData({ localStorageOnly: !0 });
		if (!e) return null;
		try {
			return (await fp.post(`${$d.url.rest}/v1/introspect`, { token: e.access_token }, { transformResponse: (e) => {
				let t = JSON.parse(e);
				return {
					...t,
					scope: t.scope ? t.scope.split(" ") : []
				};
			} })).data;
		} catch {
			return null;
		}
	}
	reset() {
		this.user = null, this.scopes = null, this._roles = null;
	}
}(), mp = (e, t) => n(() => pp.hasAccess(e, t), []);
//#endregion
export { pp as accessControl, mp as useHasAccess };

//# sourceMappingURL=index.js.map